export default __webpack_public_path__ + "static/android-icon-192x192-ca505c007ce90872d31f08b4231d538a.png";